import UserDetails from "./users-user";

export default UserDetails;
